import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../App';

const Header = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
    const systemName = process.env.REACT_APP_SYSTEM_NAME || 'ระบบลงนามถวายพระพรชัยมงคล';
    const logoUrl = process.env.REACT_APP_LOGO_URL;
    
    const handleLogout = async () => {
        await logout();
        navigate('/');
    };
    
    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };
    
    const isAdminPath = location.pathname.startsWith('/admin');
    
    return (
        <nav className={`navbar navbar-expand-lg fixed-top ${isAdminPath ? 'navbar-dark' : 'navbar-light'}`}
             style={{ 
                 background: isAdminPath ? 'var(--gradient-dark)' : 'var(--gradient-primary)',
                 boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
             }}>
            <div className="container">
                <Link className="navbar-brand d-flex align-items-center" to="/">
                    <img src={logoUrl} 
                         alt="Logo" 
                         style={{
                             width: '40px',
                             height: '40px',
                             borderRadius: '50%',
                             marginRight: '10px',
                             border: '2px solid white'
                         }} />
                    <span className="text-white fw-bold">{systemName}</span>
                </Link>
                
                <button className="navbar-toggler" 
                        type="button" 
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        style={{ border: '1px solid white' }}>
                    <span className="navbar-toggler-icon" 
                          style={{ filter: 'invert(1)' }}></span>
                </button>
                
                <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
                    <ul className="navbar-nav ms-auto">
                        {!user ? (
                            // Public Menu
                            <>
                                <li className="nav-item">
                                    <Link className={`nav-link text-white ${isActive('/')}`} to="/">
                                        <i className="fas fa-home me-1"></i> หน้าหลัก
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-white" href="#signature-form">
                                        <i className="fas fa-signature me-1"></i> ลงนามถวายพระพร
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-white" href="#signatures-list">
                                        <i className="fas fa-list me-1"></i> รายชื่อผู้ลงนาม
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <Link className={`nav-link text-white ${isActive('/login')}`} to="/login">
                                        <i className="fas fa-sign-in-alt me-1"></i> เข้าสู่ระบบ
                                    </Link>
                                </li>
                            </>
                        ) : (
                            // Admin Menu
                            <>
                                <li className="nav-item">
                                    <Link className={`nav-link text-white ${isActive('/admin/dashboard')}`} 
                                          to="/admin/dashboard">
                                        <i className="fas fa-tachometer-alt me-1"></i> แดชบอร์ด
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`nav-link text-white ${isActive('/admin/signatures')}`} 
                                          to="/admin/signatures">
                                        <i className="fas fa-signature me-1"></i> จัดการลายเซ็น
                                    </Link>
                                </li>
                                {user.role === 'super_admin' && (
                                    <li className="nav-item">
                                        <Link className={`nav-link text-white ${isActive('/admin/users')}`} 
                                              to="/admin/users">
                                            <i className="fas fa-users me-1"></i> จัดการผู้ใช้
                                        </Link>
                                    </li>
                                )}
                                <li className="nav-item">
                                    <Link className={`nav-link text-white ${isActive('/admin/settings')}`} 
                                          to="/admin/settings">
                                        <i className="fas fa-cog me-1"></i> ตั้งค่า
                                    </Link>
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle text-white" 
                                       href="#" 
                                       id="userDropdown" 
                                       role="button" 
                                       data-bs-toggle="dropdown">
                                        <i className="fas fa-user-circle me-1"></i> {user.fullname}
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                        <li>
                                            <span className="dropdown-item-text">
                                                <small className="text-muted">
                                                    {user.role === 'super_admin' ? 'Super Admin' : 'Admin'}
                                                </small>
                                            </span>
                                        </li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li>
                                            <Link className="dropdown-item" to="/">
                                                <i className="fas fa-home me-2"></i> กลับหน้าหลัก
                                            </Link>
                                        </li>
                                        <li>
                                            <button className="dropdown-item text-danger" onClick={handleLogout}>
                                                <i className="fas fa-sign-out-alt me-2"></i> ออกจากระบบ
                                            </button>
                                        </li>
                                    </ul>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;